// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__2EYzj","logo":"styles_logo__2js51"};